module.exports = __webpack_public_path__ + "img/dispositivos3.34119650.png";